// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatBodyfeedbackform {
  background: rgba(0, 0, 0, 0.6705882353);
  height: 100%;
  top: 0;
  position: fixed;
  left: 0;
}
.chatBodyfeedbackform .scroller.chatbotformtitle {
  background: #F0F1F2;
  height: 100%;
  position: relative;
  top: 72px;
  border-radius: 16px 16px 0 0;
}
.chatBodyfeedbackform .closeButton {
  position: absolute;
  right: 8px;
  top: 12px;
  z-index: 99999;
}
.chatBodyfeedbackform .titleColor {
  text-align: center;
  padding: 12px;
}
.chatBodyfeedbackform .titleColor img {
  height: 75px;
}
.chatBodyfeedbackform .titleColor p {
  font-size: 12px;
  line-height: 19px;
  margin: 6px 0;
}
.chatBodyfeedbackform .titleColor h3 {
  font-size: 14px;
  margin: 0;
}
.chatBodyfeedbackform .feedblocks {
  background: #fff;
  border-radius: 8px;
  margin: 12px;
}
.chatBodyfeedbackform .ratingBlock {
  gap: 8px;
  padding: 12px 0;
  border-bottom: 0.4px solid #d2d3d4;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.chatBodyfeedbackform .ratingBlock h5 {
  margin: 0;
  font-size: 14px;
}
.chatBodyfeedbackform .ratingBlock .ratingshow {
  display: flex !important;
  gap: 12px;
  align-items: center;
}
.chatBodyfeedbackform .questionBlock .questionBlockinner {
  padding: 12px;
}
.chatBodyfeedbackform .questionBlock .questionBlockinner p {
  margin: 0;
  font-size: 13px;
  line-height: 19px;
  font-family: "intermedium";
}
.chatBodyfeedbackform .questionBlock .questionBlockinner .ant-radio-group,
.chatBodyfeedbackform .questionBlock .questionBlockinner .ant-checkbox-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 0 0;
}
.chatBodyfeedbackform .questionBlock .questionBlockinner .ant-radio-group label,
.chatBodyfeedbackform .questionBlock .questionBlockinner .ant-checkbox-group label {
  color: #757576;
  font-size: 13px;
  font-family: "interregular";
}
.chatBodyfeedbackform .mainformscroller {
  overflow: hidden;
  overflow-y: scroll;
  height: calc(100vh - 228px);
}
.chatBodyfeedbackform .footerbutton {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  justify-content: flex-end;
}
.chatBodyfeedbackform .footerbutton button {
  margin: 0;
  background: #000;
  border-color: #000;
  width: 70px;
  font-size: 12px;
  font-family: "intermedium";
}
.chatBodyfeedbackform .footerbutton button:nth-child(1) {
  background: #fff;
  border-color: #d2d3d4;
  color: #000;
}
.chatBodyfeedbackform .closeButton {
  border: 1px solid #d2d3d4;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #f0f1f2;
}
.chatBodyfeedbackform .closeButton svg {
  width: 16px;
  height: 16px;
}
.chatBodyfeedbackform .thanksu {
  border-radius: 12px;
  border: 1px solid var(--iCon-iCon-Primary, #00B885);
  background: var(--Color-Brand-Green-Green-25, #F0FAF7);
  padding: 12px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  text-align: center;
  margin: 12px 24px;
}

.reqError {
  font-size: 13px;
  margin-left: 18px;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/feedbackstyle.scss"],"names":[],"mappings":"AAAA;EACM,uCAAA;EACA,YAAA;EACA,MAAA;EACA,eAAA;EACA,OAAA;AACN;AACM;EACM,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,4BAAA;AACZ;AAEM;EACM,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;AAAZ;AAGM;EACM,kBAAA;EACA,aAAA;AADZ;AAGY;EACM,YAAA;AADlB;AAIY;EACM,eAAA;EACA,iBAAA;EACA,aAAA;AAFlB;AAKY;EACM,eAAA;EACA,SAAA;AAHlB;AAOM;EACM,gBAAA;EACA,kBAAA;EACA,YAAA;AALZ;AAQM;EACM,QAAA;EACA,eAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AANZ;AAQY;EACM,SAAA;EACA,eAAA;AANlB;AASY;EACM,wBAAA;EACA,SAAA;EACA,mBAAA;AAPlB;AAYY;EACM,aAAA;AAVlB;AAYkB;EACM,SAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAVxB;AAakB;;EAEM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAXxB;AAawB;;EACM,cAAA;EACA,eAAA;EACA,2BAAA;AAV9B;AAgBM;EACM,gBAAA;EACA,kBAAA;EACA,2BAAA;AAdZ;AAkBM;EACM,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;AAhBZ;AAkBY;EACM,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;AAhBlB;AAkBkB;EACM,gBAAA;EACA,qBAAA;EACA,WAAA;AAhBxB;AAqBM;EACM,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAnBZ;AAqBY;EACM,WAAA;EACA,YAAA;AAnBlB;AAuBM;EACM,mBAAA;EACA,mDAAA;EACA,sDAAA;EACA,aAAA;EACA,+CAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AArBZ;;AA0BA;EACM,eAAA;EACA,iBAAA;EACA,UAAA;AAvBN","sourcesContent":[".chatBodyfeedbackform {\n      background: #000000ab;\n      height: 100%;\n      top: 0;\n      position: fixed;\n      left: 0;\n\n      .scroller.chatbotformtitle {\n            background: #F0F1F2;\n            height: 100%;\n            position: relative;\n            top: 72px;\n            border-radius: 16px 16px 0 0;\n      }\n\n      .closeButton {\n            position: absolute;\n            right: 8px;\n            top: 12px;\n            z-index: 99999;\n      }\n\n      .titleColor {\n            text-align: center;\n            padding: 12px;\n\n            img {\n                  height: 75px;\n            }\n\n            p {\n                  font-size: 12px;\n                  line-height: 19px;\n                  margin: 6px 0;\n            }\n\n            h3 {\n                  font-size: 14px;\n                  margin: 0;\n            }\n      }\n\n      .feedblocks {\n            background: #fff;\n            border-radius: 8px;\n            margin: 12px;\n      }\n\n      .ratingBlock {\n            gap: 8px;\n            padding: 12px 0;\n            border-bottom: 0.4px solid #d2d3d4;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n\n            h5 {\n                  margin: 0;\n                  font-size: 14px;\n            }\n\n            .ratingshow {\n                  display: flex !important;\n                  gap: 12px;\n                  align-items: center;\n            }\n      }\n\n      .questionBlock {\n            .questionBlockinner {\n                  padding: 12px;\n\n                  p {\n                        margin: 0;\n                        font-size: 13px;\n                        line-height: 19px;\n                        font-family: 'intermedium';\n                  }\n\n                  .ant-radio-group,\n                  .ant-checkbox-group {\n                        display: flex;\n                        flex-direction: column;\n                        align-items: flex-start;\n                        gap: 8px;\n                        margin: 12px 0 0;\n\n                        label {\n                              color: #757576;\n                              font-size: 13px;\n                              font-family: 'interregular';\n                        }\n                  }\n            }\n      }\n\n      .mainformscroller {\n            overflow: hidden;\n            overflow-y: scroll;\n            height: calc(100vh - 228px);\n\n      }\n\n      .footerbutton {\n            display: flex;\n            align-items: center;\n            padding: 12px 16px;\n            gap: 8px;\n            justify-content: flex-end;\n\n            button {\n                  margin: 0;\n                  background: #000;\n                  border-color: #000;\n                  width: 70px;\n                  font-size: 12px;\n                  font-family: 'intermedium';\n\n                  &:nth-child(1) {\n                        background: #fff;\n                        border-color: #d2d3d4;\n                        color: #000;\n                  }\n            }\n      }\n\n      .closeButton {\n            border: 1px solid #d2d3d4;\n            height: 24px;\n            width: 24px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 6px;\n            background: #f0f1f2;\n\n            svg {\n                  width: 16px;\n                  height: 16px;\n            }\n      }\n\n      .thanksu {\n            border-radius: 12px;\n            border: 1px solid var(--iCon-iCon-Primary, #00B885);\n            background: var(--Color-Brand-Green-Green-25, #F0FAF7);\n            padding: 12px;\n            box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);\n            font-size: 14px;\n            text-align: center;\n            margin: 12px 24px;\n\n      }\n}\n\n.reqError {\n      font-size: 13px;\n      margin-left: 18px;\n      color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
